<template>
  <div @click="open = true">ddd</div>
</template>

<script setup lang="ts">
import { behindJumpRegister } from "./components/behindJump/index";
import { operationLogRegister } from "./components/operationLog/index";
import { ref } from "vue";

const open = ref(true);

behindJumpRegister();
operationLogRegister('operation-log')
</script>

<style lang="less">
#app {
  height: 100%;
  overflow: hidden;
}
</style>
